import TopPicks from '@/dealership/TopPicks';
import NotFoundSearchBar from './NotFoundSearchBar';

export default function DealershipNotFoundHero() {
  return (
    <>
      <div className="border-b border-border-subtle bg-background-default px-[20px] pb-4xl pt-[36px] md:px-4xl md:pb-6xl md:pt-[72px]">
        <div className="mx-auto flex max-w-[800px] flex-col items-center gap-[20px] text-center">
          <h1 className="text-text-strong t-brand-md uppercase sm:t-brand-lg">
            Looks like this vehicle took a detour.
          </h1>
          <p className="text-text-default t-body-lg">
            This one may have already been sold, or the link is out of date.
            Start a new search below and we’ll get you back on track.
          </p>

          <div className="mt-md w-full">
            <NotFoundSearchBar />
          </div>
        </div>
      </div>

      <TopPicks />
    </>
  );
}
